import React from 'react';

import classes from './Ministerio.module.scss';

const Ministerio = props => {
    return (
        <div className={classes.Ministerio} >
            <a href={props.link} target="_blank" rel="noopener noreferrer">{props.ministerio}</a>
        </div>
    )
};

export default Ministerio;